import CancelledIcon from '@mui/icons-material/Block';
import ScheduledIcon from '@mui/icons-material/AccessTime';
import RunningIcon from '@mui/icons-material/PlayArrowOutlined';
import FinishedIcon from '@mui/icons-material/CheckOutlined';
import ArchivedIcon from '@mui/icons-material/Inventory2Outlined';
import DraftIcon from '@mui/icons-material/ReportProblemOutlined';
import ManualIcon from '@mui/icons-material/BackHand';
import {
  CancelledStatus,
  DraftStatus,
  ScheduledStatus,
  RunningStatus,
  FinishedStatus,
  ArchivedStatus,
  ManualStatus
} from "./ConversationStatus.styled";

export const ConversationStatus = ({ status }) => {
  return (
    <>
      {status.toUpperCase() === "DRAFT" && (<DraftStatus><DraftIcon sx={{ fontSize: 15 }} />Draft</DraftStatus>)}
      {status.toUpperCase() === "CANCELLED" && (<CancelledStatus><CancelledIcon sx={{ fontSize: 15 }} />Cancelled</CancelledStatus>)}
      {status.toUpperCase() === "SCHEDULED" && (<ScheduledStatus><ScheduledIcon sx={{ fontSize: 15 }} />Scheduled</ScheduledStatus>)}
      {status.toUpperCase() === "RUNNING" && (<RunningStatus><RunningIcon sx={{ fontSize: 15 }} />Running</RunningStatus>)}
      {status.toUpperCase() === "FINISHED" && (<FinishedStatus><FinishedIcon sx={{ fontSize: 15 }} />Finished</FinishedStatus>)}
      {status.toUpperCase() === "ARCHIVED" && (<ArchivedStatus><ArchivedIcon sx={{ fontSize: 15 }} />Archived</ArchivedStatus>)}
      {status.toUpperCase() === "MANUAL" && (<ManualStatus><ManualIcon sx={{ fontSize: 15 }} />Manual Mode</ManualStatus>)}
    </>
  );
};
